module.exports = __webpack_public_path__ + "static/media/silver_hero_small.23678805.png";